import './buttons.css';

const buttons = ({ onIncrease, onDecrease, isAtMax, isAtMin }) => {
  return (
    <>
      <button
        className={`upBtn ${isAtMax() ? 'disabled' : ''}`}
        disabled={isAtMax()}
        onClick={() => onIncrease}
      ></button>
      <button className={`dnBtn ${isAtMin() ? 'disabled' : ''}`} disabled={isAtMin()} onClick={onDecrease}></button>
    </>
  );
};

export default buttons;
